import { takeEvery, put, call } from 'redux-saga/effects';
import * as cdpLibActionCreators from 'pluginServices/actionCreators';
import * as pluginActionCreators from 'data/Plugin/actions';
import catchErrors from 'utils/commands/catchErrors';
import pluginService from 'services/PluginService';

import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { pluginId, version, onSuccess } = action;

  const pluginObject = yield call(pluginService.getPlugin, pluginId, version);
  if (pluginObject) {
    const { manifest, entryPoints } = pluginObject;

    /*
     * Transform
     *
     * entryPoints: [{ "context": "EDITOR" }]
     * to
     * entryPoints: { "EDITOR": {} }
     */
    manifest.entryPoints = entryPoints.reduce((accumulator, currentValue) => {
      if (currentValue.context) {
        return Object.assign({}, accumulator, { [currentValue.context]: currentValue });
      }
      return accumulator;
    }, {});

    /*
     * Save manifest and schema.
     */
    const pluginManifest = manifest;
    const pluginSchema = JSON.parse(manifest.configurationSchema);
    yield put(cdpLibActionCreators.setPluginManifest(pluginId, version, pluginManifest));
    yield put(pluginActionCreators.setPluginSchema(pluginId, pluginSchema));

    if (onSuccess) {
      onSuccess(pluginManifest, pluginSchema);
    }
  } else {
    /* Do nothing */
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_AUTHOR_PLUGIN_GET, catchErrors, sendRequest, connection);
}
